module.exports = __webpack_public_path__ + "static/media/red01.0a7e54f1.svg";